<template>
  <div>
    <RouterView />
  </div>
</template>

<script>
export default {
  name: 'LoginContainer',
  computed: {
    transitionName() {
      return this.$store.state.transitionName
    },
  },
}
</script>
